import React from "react";
import { withRouter } from "react-router";
import { AuthenticationService } from "../../services/auth.service";
import { SIGNUP_CANDIDATURE_ROUTE } from "../../providers/routes";
import { t } from "../../translations/translation.service";
import "./index.css";

class SignupExpiredToken extends React.Component<any> {
  
  handleClick = async (): Promise<void> => {
    const { username, token, opportunityId } = this.props.match.params;
    try {
      const refresh = await AuthenticationService.refreshToken(token, username);
        if (refresh.status === 200) {
            this.props.history.push(
                SIGNUP_CANDIDATURE_ROUTE
                .replace(":username", username)
                .replace(":token", token)
                .replace(":opportunityId", opportunityId)
            );
        } else {
            console.error("Failed to refresh token:", refresh.statusText);
        }
    } catch (error) {
      console.error("Error checking token:", error);
    }
  }

  render() {
    return (
      <div className="main-header">
        <h1>OOPS!!</h1>
        <div className="text-center main-container">
          <section className="section-left">
            <img src={require("../../images/enter-processing-panel.png")} alt="imagem-esquerda" className="imagem-esquerda" width={"100%"}/>
          </section>
          <section className="section-right">
            <div className="content-right">
              <div className="header-right">
                <img src={require("../../images/enter-loading.png")} alt="Logo" className="logo" />
                <h1>{t("Token Expirado")}</h1>
              </div>
              <p>{t("Seu token de validação expirou.")}</p>
              <button className="button-refresh-token" onClick={() => this.handleClick()}>{t("Clique aqui para seguir com o cadastro")}</button>
            </div>
          </section>
        </div>
      </div>
    );
  }
}
export default withRouter(SignupExpiredToken);